import styled from 'styled-components';
import { IThemeProvider } from '../../styles/theme';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Container = styled.div`
  ${({ theme }: IThemeProvider) => `
    padding: 0 ${theme.layout.spacing.centy};
  `}
`;

export const GroupCont = styled.div`
  ${({ theme }: IThemeProvider) => `
    display: flex;
    margin: ${theme.layout.spacing.centy} 0 0 0;
    padding: ${theme.layout.spacing.decy};
    background: ${theme.colors.neutral.primary[0]};
    border-radius: ${theme.layout.spacing.mikro};
  `}
`;

export const AgreementsContainer = styled.div`
  margin-top: 1rem;
  display: grid;
  width: 50%;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
  ${({ theme }: IThemeProvider) => `
    padding: 0 ${theme.layout.spacing.centy};
  `}
`;
